import React, { useEffect, useState } from "react";
import "../../Assets/Css/AddUpdateShareHolder.scss";
import { customStyle } from "../../Components/Style";
import Select from "react-select";
import showEye from "../../Assets/Images/Login-Page/showeye.png";
import hideEye from "../../Assets/Images/Login-Page/hideeye.png";
import { useNavigate, useLocation } from "react-router-dom";
import { Spinner } from 'react-bootstrap';
import {
    addShareholderGroup,
    getShareholders,
    updateShareholderGroup
} from "../../Services/Shareholders/action";
import { FaTrashAlt } from "react-icons/fa";
import { FiArrowDownLeft, FiArrowUpLeft } from "react-icons/fi";
import { useFormik } from "formik";
import { addShareholderValidation } from "../../Validations/addShareholderValidation";
import { updateShareholderValidation } from "../../Validations/updateShareholderValidation";
import { connect } from "react-redux";
import { toast } from "react-toastify";

const AddUpdateShareHolderGroup = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [x, setX] = useState(false);

    const [finalData, setFinalData] = useState({
        id: "",
        name: "",
        share_percentage: "",
    });

    const [deletedItem, setDeletedItem] = useState({
        shareholders: [],
    });

    const [groupshareholders, setGroupShareholders] = useState([]);
    const [isUpdate, setIsUpdate] = useState(false);
    const [groupData, setGroupData] = useState([]);

    let [optionTypeShareHolders, setOptionTypeShareHolders] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();
    const shareholdergroupId = location?.state?.sholderId;
    const groupedShareholders = location?.state?.groupedShareholders;


    const fetchShareHolderData = async () => {
        try {
            await props.getShareholders();
            setTheData();

        } catch (error) {
            toast.error(error);
        }
    };

    const setTheData = async () => {
        try {

            if (shareholdergroupId !== undefined) {
                setIsUpdate(true);
                setGroupData(location?.state?.data?.find(
                    (item) => item.id === shareholdergroupId
                ));
                setGroupShareholders(groupedShareholders[shareholdergroupId]);

            }
            else {

                ((await props?.shareholders) &&
                    setGroupData(await props?.shareholders));
            }
        } catch (error) {
            toast.error(error);
        }
    };




    const getShareHolderOption = () => {
        console.log(props?.shareholders);
        return props?.shareholders?.map((sh) => {
            return {
                value: sh,
                label: (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                            width: "100%",
                            margin: 0,
                            padding: 0,
                        }}
                    >
                        <div style={{
                            display: "flex",
                            flexWrap: "wrap"
                        }}>
                            <span style={{ marginRight: "10px" }}>{sh.name}</span>
                        </div>
                        <div>
                        </div>
                    </div>
                ),
            };
        })
    }

    useEffect(() => {
        fetchShareHolderData();
        getShareHolderOption();
    }, []);

    useEffect(() => {
        const options = getShareHolderOption();
        if (isUpdate) {
            let shid = props?.shareholdersgroupslist?.shareHoldersGroupsMap?.filter(item => item.group_id === shareholdergroupId);
            let filteredOptions = options?.filter(item => shid?.some(val => val.shareholder_id === item.value.id));
            filteredOptions = filteredOptions?.map((item) => {
                return {
                    ...item,
                    value: item.value,
                };
            });

            setGroupShareholders(filteredOptions);
            setOptionTypeShareHolders(options?.filter(item => !shid?.some(val => val.shareholder_id === item.value)));
        } else {
            setOptionTypeShareHolders(options);
        }
    }, [props?.shareholders]);

    useEffect(() => {
        if (isUpdate) {
            if (!shareholdergroupId) {
                toast.error("Something went wrong");
                navigate("/shareholder");
            } else {
                setFinalData({
                    id: groupData?.id,
                    name: groupData?.name,
                });
                values.name = groupData?.name;
                values.share_percentage = groupData?.share_percentage;
            }
        }
    }, [isUpdate]);


    let initalVal = {
        name: "",
        share_percentage: "",
    };

    const handleOnSubmit = async () => {
        groupshareholders.forEach(item => {
            if (!item.value.share_percentage) {
                item.value.share_percentage = isUpdate ?
                    (item?.value ? (item?.value?.shareHolderGroups.find(group => group.group_id === groupData.id)?.share_percentage) : (item?.value?.share_percentage || "")) :
                    (100 / groupshareholders.length);
            }
        });

        // Prepare data for submission
        const dataToBeUpdate = { ...finalData };
        const addSh = [];
        const updateSh = [];
        const allSelectedSh = groupshareholders.map(item => item.value);
        const deletedShId = deletedItem["shareholders"].map(item => item.id);

        allSelectedSh.forEach(item => {
            const isPresentInDeleted = item.shareHolderGroups.some(val => deletedShId?.includes(val.shareholder_id));
            if (isPresentInDeleted) {
                addSh.push({ shareholder_id: item.id, share_percentage: parseFloat(item.share_percentage) });
            } else {
                const a = props?.shareholders?.map((i) => i.id);
                console.log(a);
                const isGoingToUpdate = item.shareHolderGroups.find(val => a.includes(val.shareholder_id));
                if (isGoingToUpdate) {
                    updateSh.push({ id: isGoingToUpdate.id, shareholder_id: item.id, share_percentage: parseFloat(item.share_percentage) });
                } else {
                    addSh.push({ shareholder_id: item.id, share_percentage: parseFloat(item.share_percentage) });
                }
            }
        });

        try {
            if (isUpdate) {
                // Updation Logic
                let requestData = {
                    ...dataToBeUpdate,
                    shareHoldersGroupsMap: groupshareholders.map((val) => {
                        console.log(val, ' <== val');
                        return {
                            shareholder_id: val.value.id,
                            share_percentage: val.value.share_percentage,

                        };
                    }),
                };
                props.updateShareholderGroup(shareholdergroupId, requestData);
            } else {
                // Creation / Add Logic
                let addData = {
                    ...dataToBeUpdate,
                    shareHoldersGroupsMap: groupshareholders.map((val) => {
                        return {
                            shareholder_id: val.value.id,
                            share_percentage: val.value.share_percentage,
                        };
                    }),
                };
                props.addShareholderGroup(addData);
                values.name = "";

                const options = getShareHolderOption();
                setOptionTypeShareHolders(options);
            }
            setIsLoading(false);
            navigate('/shareholder/group');
        } catch (error) {
            console.log("error", error);
        }
    };


    let { values, errors, touched, handleChange, handleSubmit } = useFormik({
        initialValues: initalVal,
        validationSchema: isUpdate === false ? addShareholderValidation : updateShareholderValidation,
        onSubmit: handleOnSubmit
    });

    useEffect(() => {
        setFinalData({ ...values });
    }, [values]);

    const handleDeleteShareHolder = (valueToDelete) => {
        console.log(valueToDelete.value.shareHolderGroups, ' <=== valueToDelete');
        if (isUpdate) {
            let isDataPresent = props?.shareholdersgroupslist?.shareHoldersGroupsMap?.find(item => item.shareholder_id == valueToDelete.value.id);
            if (isDataPresent) {
                const a = props?.shareholders?.map((i) => i.id);
                console.log(a);

                let deletes = valueToDelete.value.shareHolderGroups.find(item => a.includes(item.shareholder_id));
                console.log(deletes, ' <=== deletes');
                let deleteField = { id: deletes.id, shareholder_id: deletes.shareholder_id };
                setDeletedItem({
                    ...deletedItem,
                    shareholder: [...deletedItem["shareholders"], deleteField],
                });
            }
        }
        const filteredValues = groupshareholders?.filter((val) => val.value.id !== valueToDelete.value.id);
        setGroupShareholders(filteredValues);
        const aleredyPresentShareHolder = optionTypeShareHolders.some(item => item.value.id === valueToDelete.value.id);
        if (aleredyPresentShareHolder === false) {
            optionTypeShareHolders = optionTypeShareHolders || [];
            valueToDelete.value.share_percentage = "";
            const data = [...optionTypeShareHolders, valueToDelete];
            let sortedData = data.sort((a, b) => a.value.id - b.value.id);
            setOptionTypeShareHolders(sortedData);
        }
    };
    const handlePercentage = (e, selectedVal, index) => {
        setX(true);

        const updatedShareholders = groupshareholders.map((sh, i) => {
            if (sh.value.id === selectedVal.value.id) {
                // const sharePercentageOfGroup = selectedVal?.value?.shareHolderGroups.find(group => group.group_id === groupData.id)?.share_percentage;

                return {
                    ...sh,
                    value: {
                        ...sh.value,
                        share_percentage: e.target.value,
                    },
                };
            }
            return sh;
        });
        setGroupShareholders(updatedShareholders);
        console.log(updatedShareholders, ' <=== updatedShareholders');
        setOptionTypeShareHolders(optionTypeShareHolders?.filter((val) => val.value.id !== selectedVal.value.id));
    }
    return (
            <div className="addUpdateShareholder-main">
                <div className="page-title">
                    <h4>{isUpdate ? "Update" : "Add"} Share Holder Group</h4>
                    <div className="edit-btn">
                        <button className="custom-btn" type="submit" onClick={handleSubmit}>
                            {props.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Save'}
                        </button>
                    </div>
                </div>
                <div className="content-part">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="left-part" style={{ display: "block" }}>
                                <div className="custom-row">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="input-group">
                                                <h6 className="label">Group Name</h6>
                                                <input
                                                    disabled={isLoading}
                                                    type="text"
                                                    value={values.name}
                                                    name="name"
                                                    onChange={handleChange}
                                                    className="input-css"
                                                />
                                                {errors.name && touched.name ? (
                                                    <p className="error-text">{errors.name}</p>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="input-group">
                                                <h6 className="label">Share Holders</h6>
                                                <Select
                                                    isMulti
                                                    disabled={isLoading}
                                                    styles={customStyle}
                                                    options={optionTypeShareHolders || []}
                                                    value={groupshareholders}
                                                    onChange={(value) => {
                                                        setGroupShareholders(value);
                                                    }}
                                                    controlShouldRenderValue={false}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#5757fe",
                                                            primary: "#5757fe",
                                                        },
                                                    })}
                                                />
                                                <ul className="ListMenu">
                                                    {groupshareholders && groupshareholders?.map((selectedValue, index) => {
                                                        return <li key={index}>
                                                            {selectedValue.label}
                                                            <div style={{ display: "flex" }} className="second-part-list">
                                                                <span style={{ whiteSpace: "nowrap" }}>Percentage : </span>
                                                                &nbsp;
                                                                <input type="number"
                                                                    className="input-css"
                                                                    value={x ? (selectedValue?.value?.share_percentage) : (isUpdate ?
                                                                        x ? (selectedValue?.value?.share_percentage) : selectedValue?.value?.shareHolderGroups.find(group => group.group_id === groupData.id)?.share_percentage :
                                                                        (100 / groupshareholders.length))}

                                                                    onChange={(e) => handlePercentage(e, selectedValue, index)}
                                                                    style={{
                                                                        width: "150px"
                                                                    }}
                                                                /> &nbsp;
                                                                <FaTrashAlt
                                                                    style={{ marginLeft: "5px" }}
                                                                    className="deleteIcon"
                                                                    onClick={() => handleDeleteShareHolder(selectedValue)}
                                                                />
                                                            </div>
                                                        </li>
                                                    }
                                                    )}

                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
    );
};

const mapStateToProps = (state) => {
    return {
        loading: state.shareholdersReducer.loading,
        success: state.shareholdersReducer.success,
        shareholders: state.shareholdersReducer?.shareholders?.rows,
        shareholdersgroupslist: state.shareholdersReducer.shareholdersgroupslist,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {

        getShareholders: (params) => {
            dispatch(getShareholders(params));
        },
        addShareholderGroup: (postData) => {
            dispatch(addShareholderGroup(postData));
        },
        updateShareholderGroup: (id, postData) => {
            dispatch(updateShareholderGroup(id, postData))
        },
        getShareholdersGroupsList: () => {
            dispatch(getShareholdersGroupsList());
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AddUpdateShareHolderGroup);
